/**
 * Description info component.
 * Displays subscription status, date, catchup availability, and age code information
 * in the middle section of content descriptions.
 */
import Classification from '@components/elements/description/descriptionClassification';
import Container from '@components/atoms/container/descriptionInfoContainer';
import Date from '@components/elements/description/descriptionDate';
import Facts from '@components/elements/description/descriptionFacts';
import Subscription from '@components/elements/addons/descriptionAddonSubscription';

/**
 * Renders the information section of content descriptions.
 * Shows subscription status, date, catchup availability, and age code information.
 *
 * @returns {JSX.Element} Description info component
 */
export default function DescriptionInfo() {
  return (
    <Container id='descriptionInfo'>
      <Subscription />
      <Facts />
      <Date />
      <Classification />
    </Container>
  );
}
